import { ReactNode } from 'react'

import clsx from 'clsx'

import { NavigationColor, navIconColorSelectChildClass } from '@/components/view/utils/nav/navigation'

const Content = ({ parent, children, opening = true, color, grandChild = false }: Props) => {
  return (
    <>
      {parent}
      {children && (
        <div
          className={clsx(
            'accordion',
            opening && 'opening rounded-br-lg',
            color && navIconColorSelectChildClass(color)
          )}
        >
          <ul>
            {children.map((child: ReactNode, index) => (
              <li key={index}>{child}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

interface Props {
  parent: ReactNode
  children?: ReactNode[]
  opening?: boolean
  color?: NavigationColor
  grandChild?: boolean
}

const NavigationList = ({ parent, children, opening = true, color, grandChild = false }: Props) => {
  if (grandChild) {
    return <Content parent={parent} children={children} opening={opening} color={color} grandChild={grandChild} />
  }

  return (
    <li className='list-none'>
      <Content parent={parent} children={children} opening={opening} color={color} grandChild={grandChild} />
    </li>
  )
}

export default NavigationList
